import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from './queryKeys';

const getDocsIdByBind = async (id) => {
  return await request.get(
    `/Docs/${id}/bind`,
    null,
    'При получени связанных объектов произошла ошибка'
  );
};

const useDocsIdByBind = (id, options) =>
  useQuery(queryKeys.bindByDocs(id), () => getDocsIdByBind(id), options);

export default useDocsIdByBind;
